export const handleFilters = (mSectionName: any, localAuxPayload: any) => {
  if (!mSectionName || !localAuxPayload[mSectionName]) return localAuxPayload;

  const mAuxPayload = { ...localAuxPayload };
  const sectionPayload = { ...mAuxPayload[mSectionName] };

  const {
    total_or_price_per_carat,
    price_total_from,
    price_total_to,
    price_per_carat_from,
    price_per_carat_to,
  } = sectionPayload;

  const isUndefinedOrEmpty = (value: any) =>
    value === undefined || value === "";

  const shouldRemoveFilters = () =>
    isUndefinedOrEmpty(price_total_from) &&
    isUndefinedOrEmpty(price_total_to) &&
    isUndefinedOrEmpty(price_per_carat_from) &&
    isUndefinedOrEmpty(price_per_carat_to);

  if (total_or_price_per_carat !== undefined) {
    if (shouldRemoveFilters()) {
      delete sectionPayload.total_or_price_per_carat;
    } else if (total_or_price_per_carat === "total_sales_price") {
      delete sectionPayload.price_per_carat_from;
      delete sectionPayload.price_per_carat_to;
      if (
        isUndefinedOrEmpty(price_total_from) &&
        isUndefinedOrEmpty(price_total_to)
      ) {
        delete sectionPayload.total_or_price_per_carat;
      }
    } else if (total_or_price_per_carat === "price_per_carat") {
      delete sectionPayload.price_total_from;
      delete sectionPayload.price_total_to;
      if (
        isUndefinedOrEmpty(price_per_carat_from) &&
        isUndefinedOrEmpty(price_per_carat_to)
      ) {
        delete sectionPayload.total_or_price_per_carat;
      }
    }
  } else {
    if (price_total_from !== undefined || price_total_to !== undefined) {
      sectionPayload.total_or_price_per_carat = "total_sales_price";
    } else if (
      price_per_carat_from !== undefined ||
      price_per_carat_to !== undefined
    ) {
      sectionPayload.total_or_price_per_carat = "price_per_carat";
    }
  }

  mAuxPayload[mSectionName] = sectionPayload;

  return mAuxPayload;
};

export const normalizeBoolean = (val: any) => {
  if (val === true || val === "true") return true;
  if (val === false || val === "false") return false;
  return Boolean(val);
};

export const getMinMaxForShape = (
  modifyShapeSupportForBuilder: boolean,
  min_max_Options: any,
  shapeFilter: any
) => {
  if (!modifyShapeSupportForBuilder) {
    return {
      minOption: null,
      maxOption: null,
    };
  }
  const match = min_max_Options?.carat_range.find(
    (opt: any) =>
      opt?.supported_shapes?.toLowerCase() === shapeFilter?.toLowerCase()
  );

  if (!match) return null;

  return {
    minOption: match ? match.min_value : null,
    maxOption: match ? match.max_value : null,
  };
};
